import { Link } from "react-router-dom";
import { ArrowRight, Droplets } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { SERVICES } from "../lib/services";

export const ServiceCards = () => (
  <section data-testid="service-cards-section" className="py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal className="max-w-2xl">
        <Overline>What We Clean</Overline>
        <h2 className="mt-4 font-display font-medium text-4xl sm:text-5xl lg:text-6xl leading-[1.08] tracking-tight text-brand-ink">
          Professional Cleaning Services <span className="font-serif italic text-brand">Across Gold Coast</span>
        </h2>
        <p className="mt-5 text-base sm:text-lg text-brand-muted leading-relaxed">
          Every service below is delivered with the same approach: assess first, clean
          appropriately, and give you an honest expectation of the result.
        </p>
      </Reveal>

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {SERVICES.map((s, i) => (
          <Reveal key={s.slug} delay={0.05 * (i % 3)}>
            <article
              data-testid={`service-card-${s.slug}`}
              className={`group h-full flex flex-col bg-white border rounded-2xl overflow-hidden shadow-[0_4px_40px_rgba(0,0,0,0.04)] hover:shadow-[0_20px_60px_rgba(45,90,83,0.12)] hover:-translate-y-1 transition-[box-shadow,transform] duration-500 ${
                s.urgent ? "border-brand/60 ring-1 ring-brand/30" : "border-brand-line/60"
              }`}
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={s.image}
                  alt={s.imageAlt}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                {s.urgent && (
                  <span className="absolute top-3 left-3 inline-flex items-center gap-1.5 bg-brand-dark text-white text-[10px] font-bold tracking-[0.14em] uppercase px-3 py-1.5 rounded-full">
                    <Droplets size={11} /> Urgent Help
                  </span>
                )}
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="font-display text-xl font-medium tracking-tight text-brand-ink">{s.menu}</h3>
                <p className="mt-2 text-sm text-brand-muted leading-relaxed flex-1">
                  {s.intro.split(". ")[0]}.
                </p>
                <div className="mt-5 flex items-center gap-4">
                  <Link
                    to={`/${s.slug}`}
                    data-testid={`service-card-learn-${s.slug}`}
                    className="group/l inline-flex items-center gap-1.5 text-sm font-semibold text-brand"
                  >
                    Learn More
                    <ArrowRight size={14} className="transition-transform duration-300 group-hover/l:translate-x-1" />
                  </Link>
                  <Link
                    to="/get-estimate"
                    data-testid={`service-card-estimate-${s.slug}`}
                    className="text-sm font-semibold text-brand-muted hover:text-brand transition-colors duration-300"
                  >
                    Get Estimate
                  </Link>
                </div>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
